import { render, staticRenderFns } from "./AccountFavorites.vue?vue&type=template&id=d8e4b7e4&"
import script from "./AccountFavorites.vue?vue&type=script&lang=js&"
export * from "./AccountFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports